var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFleetCost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 13C34.6666 8.91366 34.6666 6.87266 33.397 5.60299C32.1273 4.33333 30.0863 4.33333 26 4.33333C21.9136 4.33333 19.8726 4.33333 18.603 5.60299C17.3333 6.87266 17.3333 8.91366 17.3333 13M4.33331 30.3333C4.33331 22.1628 4.33331 18.0765 6.87265 15.5393C9.41198 13.0022 13.4961 13 21.6666 13H30.3333C38.5038 13 42.5901 13 45.1273 15.5393C47.6645 18.0787 47.6666 22.1628 47.6666 30.3333C47.6666 38.5038 47.6666 42.5902 45.1273 45.1273C42.588 47.6645 38.5038 47.6667 30.3333 47.6667H21.6666C13.4961 47.6667 9.40981 47.6667 6.87265 45.1273C4.33548 42.588 4.33331 38.5038 4.33331 30.3333Z",
    stroke: "#CCCCCC",
    strokeWidth: 3.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 37.5548C28.3941 37.5548 30.3333 35.9385 30.3333 33.9452C30.3333 31.9518 28.3941 30.3333 26 30.3333C23.6058 30.3333 21.6666 28.717 21.6666 26.7215C21.6666 24.7282 23.6058 23.1118 26 23.1118M26 37.5548C23.6058 37.5548 21.6666 35.9385 21.6666 33.9452M26 37.5548V39M26 23.1118V21.6667M26 23.1118C28.3941 23.1118 30.3333 24.7282 30.3333 26.7215",
    stroke: "#CCCCCC",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetCost);
export default __webpack_public_path__ + "static/media/Fleet_Cost.94b6a7bf2ce2e7f7a52fa6fca369f5a3.svg";
export { ForwardRef as ReactComponent };